module.exports = __webpack_public_path__ + "img/back.0d5494a2.png";